import React from 'react';

const HeroSection = () => (
  <section
    id="soluciones-integrales"
    className="relative w-full overflow-hidden bg-cover bg-center py-16 md:py-28 lg:py-36 xl:py-48"
    style={{ backgroundImage: "url('/foreign-trade-hero.jpg')" }}
  >
    <div className="absolute inset-0 bg-gray-950/80" aria-hidden="true" />
    <div className="absolute inset-0 bg-gradient-to-b from-gray-950/50 via-transparent to-gray-950/40" aria-hidden="true" />
    <div className="container relative px-4 md:px-6">
      <div className="flex flex-col items-center space-y-5 text-center">
        <h1 className="max-w-5xl text-4xl font-bold leading-[1.12] tracking-normal text-white sm:text-5xl md:text-6xl lg:text-7xl">
          Soluciones Integrales en Comercio Exterior
        </h1>
        <p className="max-w-[700px] text-gray-100 md:text-xl">
          Optimizamos tus operaciones aduanales con tecnología de vanguardia y asesoría especializada.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <a
            href="#contacto"
            className="inline-flex h-10 items-center justify-center rounded-md bg-teal-500 px-8 text-sm font-medium text-gray-950 shadow transition-colors hover:bg-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950 disabled:pointer-events-none disabled:opacity-50"
          >
            Contáctanos
          </a>
          <a
            href="#servicios"
            className="inline-flex h-10 items-center justify-center rounded-md border border-white/70 bg-white/10 px-8 text-sm font-medium text-white shadow-sm backdrop-blur-sm transition-colors hover:bg-white hover:text-gray-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950 disabled:pointer-events-none disabled:opacity-50"
          >
            Nuestros Servicios
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
